import { IPayrollChangeRequestState } from '@/store/payrollchangerequest';
import { IPayrollChangeRequestGetters } from './getters.types';
import {
  IPayrollChangeRequest,
  IUserData,
  PayrollChangeRequest,
  User
} from '@/models';
import { Transition } from '@/models/transition';

export const getters: IPayrollChangeRequestGetters = {
  getPayrollChangeRequests(
    state: IPayrollChangeRequestState
  ): IPayrollChangeRequest[] {
    return state.payrollChangeRequests.map(
      data => new PayrollChangeRequest(data)
    );
  },

  getPayrollChangeRequestCount(state: IPayrollChangeRequestState): number {
    return state.count;
  },

  getPayrollChangeRequestById: (state: IPayrollChangeRequestState) => (
    id: number
  ): IPayrollChangeRequest | undefined => {
    const data = state.payrollChangeRequests.find(
      payrollChangeRequest => payrollChangeRequest.id === id
    );
    if (!data) {
      return undefined;
    }

    return new PayrollChangeRequest(data);
  },

  getPayrollChangeRequestActivities: (
    state: IPayrollChangeRequestState
  ): Transition[] => {
    return state.activities.map(data => new Transition(data));
  },

  //hr
  getPayrollChangeRequestHRPersonnels(
    state: IPayrollChangeRequestState
  ): IUserData[] {
    return state.hrPersonnels.map(data => new User(data));
  }
};
